import { render, staticRenderFns } from "./CaseFileDisplay.vue?vue&type=template&id=3d4b7b41&scoped=true&"
import script from "./CaseFileDisplay.vue?vue&type=script&lang=ts&"
export * from "./CaseFileDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFileDisplay.vue?vue&type=style&index=0&id=3d4b7b41&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4b7b41",
  null
  
)

export default component.exports